import { render, staticRenderFns } from "./CustomerPageComponent.vue?vue&type=template&id=a6454082"
import script from "./CustomerPageComponent.vue?vue&type=script&lang=ts"
export * from "./CustomerPageComponent.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports